<script>
  import { getContext } from 'svelte'
  import ReviewModal from './ReviewModal.svelte'

  export let reviewerName
  export let reviewChannel
  export let reviewRating
  export let reviewContent
  export let reviewerEmail
  export let reviewerImage
  export let settings
  export let reviewImages
  export let hasMoreContent
  export let reviewDate

  const ENTER_KEY = 13

  const { open } = getContext('kudobuzz-modal')

  const showModal = () => {
    open(
      ReviewModal,
      {
        reviewerName,
        reviewChannel,
        reviewRating,
        reviewContent,
        reviewerImage,
        reviewerEmail,
        settings,
        reviewImages,
        reviewDate
      },
      { modalName: 'slider modal', isModalDialog: hasMoreContent }
    )
  }

  const handleOpenModalWithEnterKey = e => {
    if (e.keyCode === ENTER_KEY) {
      showModal()
    }
  }
</script>

<div
  tabindex={hasMoreContent ? 0 : -1}
  role={hasMoreContent ? 'button' : ''}
  aria-label={hasMoreContent ? 'click to expand and read and review' : ''}
  dir={settings.widget_settings.general_settings.text_direction}
  on:click={showModal}
  on:keyup={hasMoreContent ? handleOpenModalWithEnterKey : ''}
  style={hasMoreContent ? 'cursor: pointer;' : 'pointer-events: none;'}>
  <slot />
</div>
